export class Measure {
  public id: number;
  public title: string;
  public content: string;
  public placeholder: string;
  public pia_id: number;
  public created_at: Date;
  public updated_at: Date;
  public lock_version: number;
}
